import { z } from "zod";

/**
 * Tier values exposed on the client/API contract. The cap policy
 * itself (Lite: 1 site / 1 panel / 20 circuits / 8 lifetime AI scans /
 * 10 photos / watermarked outputs per `MVP.md` §3.1) lives on the
 * server side (`apps/api/src/auth/tier-caps.ts`, Phase 12b).
 */
export const tierSchema = z.enum(["lite", "home", "pro"]);
export type Tier = z.infer<typeof tierSchema>;

/**
 * Payload returned on a `TIER_CAP_EXCEEDED` error per Phase 12b. The
 * client needs `cap` + `current` + `limit` to render the upgrade
 * prompt; `upgradeTo` and `triggerReason` map to `MVP.md` §4.9's
 * prompt text.
 */
export const tierCapExceededPayloadSchema = z.object({
  cap: z.string().min(1),
  current: z.number().int().nonnegative(),
  limit: z.number().int().nonnegative(),
  upgradeTo: tierSchema,
  triggerReason: z.string().min(1),
});
export type TierCapExceededPayload = z.infer<typeof tierCapExceededPayloadSchema>;
